import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { TranslationService } from 'src/app/services/translation.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController } from '@ionic/angular';
import { NgxSmartModalService } from 'ngx-smart-modal';

// declare function openChat(username: string, userEmail: string, teamleaderGUID: string, documentGUID: string):any;

@Component({
  selector: 'app-quickscanresult',
  templateUrl: './quickscanresult.page.html',
  styleUrls: ['./quickscanresult.page.scss'],
})
export class QuickscanresultPage implements OnInit {
  @ViewChild("focusAlert") focusAlert: ElementRef;
  showPage : boolean = false
  result: any
  count: number;
  moduleList:any = [];
  remarks: string = '';
  showUpgradeButton: boolean = false
  // showTrengoChat: boolean = false
  isStartPage: boolean = false
  isReportOnly: boolean = false
  quickScanName: string = '';

  @Input() rating: number = 0;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter(); 

  constructor( private datePipe: DatePipe, private location: Location, private _formBuilder: FormBuilder, private _translationService: TranslationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService,private formBuilder: FormBuilder, public _commonService: CommonService, private popoverController: PopoverController, public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.getModuleList()
    if(localStorage.domainSubscription &&  localStorage.domainSubscription == 'DomainSubscription_Try'){
      if(localStorage.roleCode == 'UserRole_CustomerAdmin'){
        this.showUpgradeButton = true
        // this.showTrengoChat = false
      }
    }else{
      if(localStorage.roleCode == 'UserRole_CustomerAdmin'){
        // this.showTrengoChat = true
        this.showUpgradeButton = false
      }
    }
    if(sessionStorage.isDashBoardQuickScan &&  (JSON.parse(sessionStorage.isDashBoardQuickScan) == true)){
      this.isReportOnly = true
    }else{
      this.isReportOnly = false
    }
    this.isStartPage = false
    this.getResultDetail()
    
  }


  async getResultDetail(){
    try {
      this.count = 0;
      this._commonService.presentLoading()
      let res = await this._apiService.endQuickScanReport(sessionStorage.QuickScanFormId, this.isReportOnly);
      this.quickScanName = res.body.QuickScan?res.body.QuickScan.QuickScanName:'';
      this.result = res.body.Suggestions?res.body.Suggestions:[];
      this.result.forEach(element => {
        if(element.SuggestionType == 'ResultType_OK'){
          this.count ++
        }
        if(element.ModuleId){

          let k = this.moduleList.find(x=>x.guid==element.ModuleId).name_systemtranslationcode;
          if(k){
            element.Module = k
          }
        }
        
      });
     console.log(this.result)
      this._commonService.dismiss()
      this.showPage = true
      //this.downloadFile()
     
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  async downloadFile(){
    try {
      event.stopPropagation();
      this._commonService.presentLoading();
      
        let res = await this._apiService.downloadQuickScanReport(sessionStorage.QuickScanFormId);
        this._commonService.dismiss();
       let  blob = new Blob([res.body])
      const url = window.URL.createObjectURL(blob);
      let name = 'quickscanreport_' + this.datePipe.transform(new Date(), "yyyyMMddHHmmss")
      const fileName = name + '.pdf';
      
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = res.headers.get('x-blob-filename')?res.headers.get('x-blob-filename'):fileName;
      downloadLink.click();
      blob = new Blob([res.body], { type: 'application/pdf' });
      let newWindow = window.open('', "_blank");
      newWindow.location.href = URL.createObjectURL(blob);
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async goToModuleLink(id,RefExternal){
        let k = this.moduleList.filter(x=>x.guid==id);
        if(k){
          if(k[0].name_systemtranslationcode=='Module_FAQ'){
            if(RefExternal!=null){
              // this.router.navigate(['/frequentlyaskedquestions/' + RefExternal]);
              if (this.route.snapshot['_routerState'].url != '/frequentlyaskedquestions') {
                let faq = {
                  CategoryId: RefExternal[0].CategoryId,
                  FaqId : RefExternal[0].RefExternalId
                }
                if (this._commonService.isLoggedIn && localStorage.domainName != 'MASTER') {
                  const navigationExtras: NavigationExtras = {
                    state: { faq }
                  };
                  this.router.navigate(['frequentlyaskedquestions'], navigationExtras);
                }
              }
            } else {
              this.router.navigate(['/frequentlyaskedquestions']);
            }
            
          }else if(k[0].name_systemtranslationcode=='Module_DocumentGenerator'){
            if(RefExternal!=null){
              this.router.navigate(['/documentgenerator/wizard/' + RefExternal[0].RefExternalId + '/' + RefExternal[0].DocumentTemplateVersionId]);
            } else {
              this.router.navigate(['/documentgenerator']);
            }
          }else if(k[0].name_systemtranslationcode=='Module_StandardDocument'){
            if(RefExternal!=null){
              this.router.navigate(['/documentlibrary/' + 'standarddocument/' + RefExternal[0].RefExternalId + "/" + localStorage.domainId]);
            } else {
              this.router.navigate(['/documentlibrary']);
            }

          }else if(k[0].name_systemtranslationcode=='Module_Quickscan'){
            if(RefExternal!=null){
              this.router.navigate(['/documentlibrary/' + 'documents/' + RefExternal[0].RefExternalId + "/" + localStorage.domainId]);
            } else {
              this.router.navigate(['/documentlibrary']);
            }
          }else if(k[0].name_systemtranslationcode=='Module_Notification'){
            if(RefExternal!=null){
              this.router.navigate(['/notifications/' + RefExternal]);

            } else {
              this.router.navigate(['/notifications']);
            }

          }else if(k[0].name_systemtranslationcode=='Module_Messageboard'){
            if(RefExternal!=null){
              this.router.navigate(['maintenance/messages/' + RefExternal]);
            } else {
              this.router.navigate(['/frequentlyaskedquestions']);
            }

          }
        }
  }

  openRatingModal(row){
    this.rating = 0;
    this.remarks = ''
   this.ngxSmartModalService.getModal('QuickScanRatingModal').open();
   setTimeout(() => {
    this.focusAlert.nativeElement.focus();
    document.getElementById('alertFocus').classList.add("rating-alert-button");
  }, 100);
  }

  async RateAndCloseModal(){
    this.ngxSmartModalService.getModal('QuickScanRatingModal').close();
    try {
      let moduleId='';
      this._commonService.presentLoading();
      let k = JSON.parse(localStorage.moduleList);
      if(k){
        let l = k.find(x=>x.name_systemtranslationcode == "Module_Quickscan");
        if(l){
          moduleId = l.guid
        }
      }
       let data={
          "ModuleId": moduleId,
          "UserRating": this.rating ? this.rating : null,
          "UserRemark": this.remarks ? this.remarks : null,
          "ExternalRefId": sessionStorage.QuickScanId
         }
    let res = await  this._apiService.postUserRatings(data);
    if(res.id){
  
    }
    this._commonService.dismiss();
    this._commonService.showToast(this._commonService.getLocalTranslation('label-feedbackGiven'));
    this._commonService.log(data, this._commonService.LOG);
    } catch (error) {
      this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
    }
    
  }

  ionViewWillLeave(){
  this.showUpgradeButton = false;
  // this.showTrengoChat = false
  this.isStartPage = true
  if(sessionStorage.isDashBoardQuickScan){
    sessionStorage.removeItem('isDashBoardQuickScan')
    this.isReportOnly = false
  }
  }

  async closeRatingModal(){
    this.ngxSmartModalService.getModal('QuickScanRatingModal').close();  
  }
  rate(index: number) {
    this.rating = index;
    this.ratingChange.emit(this.rating);
 }

 getColor(index: number) {
  if (index) {
    if (this.isAboveRating(index)) {
      return "../assets/star_favorite.svg";
    } else {
      return "../assets/star_favorite_fill.svg";
    }
  } else {
    return "../assets/star_favorite.svg";
  }

}

isAboveRating(index: number): boolean {
  return index > this.rating;
}

gotoSubscription(){
 
    this._commonService.isFromQuickScan = true
    this.router.navigate(['maintenance/domains/',localStorage.domainId]);
  
}

  
  // export() {
  //   this._commonService.presentLoading();


  //   this._apiService.exportQuickScanReport('', 'd87ba1b1-3687-4f6a-b67c-1b39ba483daa').then((data) => {
  //     let blob = new Blob([data.body], { type: data.body.type });

  //     let link = document.createElement("a");

  //     link.href = URL.createObjectURL(blob);
  //     link.setAttribute('visibility', 'hidden');
  //     link.download =  "TotalReport" + ".pdf";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     this._commonService.dismiss();
  //   }).catch(err => {
  //     this._commonService.dismiss();
  //     this._commonService.log(err, this._commonService.ERROR);
  //   })
  // }



  goBack(){
    this.location.back()
  }

  onActionChange(obj) {

    switch (obj.Action) {
    
      case "back":
          this.goBack();
          break;  
      }
      
      
  }

  // startTrengoChat(){
  //   var email = localStorage.userName ? localStorage.userName : "Unknown";
  //   var firstName = localStorage.firstName ? localStorage.firstName : "Unknown";
  //   var teamleaderGUID = localStorage.TeamLeaderGuid ?  localStorage.TeamLeaderGuid : 'Unknown';
    
  //   openChat(firstName, email, teamleaderGUID, sessionStorage.QuickScanId);
  // }

  async getModuleList(){
    try{
      if(localStorage.moduleList){
        this.moduleList = JSON.parse(localStorage.moduleList)
      }else{
        let moduleList = await this._apiService.getModules('', '', '', 1, 0);
        this.moduleList = moduleList.body
        localStorage.moduleList = JSON.stringify(moduleList.body);
      }
  
    }catch(error){
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
    }
  }

}
